import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthProvider';
import { signout } from '../../api/sportaloka-client';
import { Link } from 'react-router-dom';

function AccountMenu({ avatar }) {
  const [, dispatch] = useContext(AuthContext);
  const handleSignout = async () => {
    if (localStorage.getItem('accessToken')) {
      try {
        await signout();
        dispatch({ type: 'SIGNOUT' });
      } catch (error) {
        dispatch({ type: 'SIGNOUT' });
      }
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="searchMenu-loc js-form-dd js-liverSearch ml-20">
      <div
        className="d-flex items-center"
        data-bs-toggle="dropdown"
        data-bs-auto-close="true"
        data-bs-offset="0,22">
        <img src={avatar} alt="avatar" className="rounded-circle navbar-avatar" />
      </div>

      <div className="shadow-2 dropdown-menu min-width-200 account-menu">
        <div className="bg-white px-20 py-20 sm:px-0 sm:py-15 rounded-4">
          <ul className="y-gap-5 js-results">
            <li className={`-link d-block col-12 text-left rounded-4 js-search-option mb-1`}>
              <Link to={`/settings`} className="d-flex items-center px-20 py-15">
                <div className="d-flex items-center">
                  <div className="fa fa-cog text-light-1 text-18 pt-4" />
                  <div className="ml-15">
                    <div className="text-14 lh-12 fw-500 js-search-option-target">Pengaturan</div>
                  </div>
                </div>
              </Link>
            </li>
            <li className={`-link d-block col-12 text-left rounded-4 js-search-option mb-1`}>
              <div
                onClick={handleSignout}
                className="d-flex items-center px-20 py-15 cursor-pointer">
                <div className="d-flex items-center">
                  <div className="fa fa-sign-out text-light-1 text-18 pt-4" />
                  <div className="ml-15">
                    <div className="text-14 lh-12 fw-500 js-search-option-target">Keluar</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AccountMenu;
